<template>
  <div id="destaque" :style="{ opacity: clientOpacity }">
    <b-container id="conteudoDestaque">
      <b-row id="destaqueGrande" v-if="$route.name === 'Home'">
        <b-col class="text-center" sm="12" lg="4">
          <a id="ultimaEdicao" :href="downloadEdition(editionId)">
            <img
              class="imgHover img-fluid"
              v-b-tooltip.hover.righttop
              :src="gazetaTopo"
              title="Veja a última edição do diário"
              alt="Veja a última edição do diário"
            />
          </a>
          <div class="efeitoMultiply img-fluid"></div>
        </b-col>
        <b-col sm="12" lg="8" class="pt-lg-4 pb-sm-4">
          <h3 class="mt-sm-5 mt-lg-5">{{ tituloDestaque }}</h3>
          <p v-html="descricaoDestaque"></p>
          <b-button
            :href="downloadEdition(editionId)"
            class="botaoDestaque d-table mb-4 mb-sm-0 mb-md-0 mb-lg-0 mb-xl-0"
          >
            ver edição
          </b-button>
        </b-col>
      </b-row>
      <b-row id="destaqueReduzido" v-else>
        <b-col
          cols="12"
          sm="12"
          md="12"
          lg="7"
          xl="7"
          class="pt-4 pt-lg-3"
          offset-lg="1"
          offset-xl="1"
        >
          <h3>{{ tituloDestaque }}</h3>
          <p v-html="descricaoDestaque" class="mb-0 mb-lg-3"></p>
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="4" xl="4">
          <b-button
            :href="downloadEdition(editionId)"
            class="botaoDestaque d-table mb-4 mb-md-0"
          >
            ver edição
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid id="barraSecundaria"></b-container>
  </div>
</template>

<script>
  import axios from 'axios'
  import PortalApi from '@/api/portal'
  import client from '@/main.js'
  export default {
    name: 'Destaque',
    data() {
      return {
        client: null,
        tituloDestaque: '',
        descricaoDestaque: `Visualize a última edição na íntegra, clique no botão abaixo para acessá-la.`,
        editionId: [],
        gazetaTopo: ''
      }
    },
    created() {
      let me = this
      me.fetchEditions()
      me.client = client.CLIENT
      me.gazetaTopo = require('@/assets/imagens/' +
        me.client +
        '/gazetaTopo1.png')
      me.tituloDestaque = client.clientData.spotlight.title
      me.descricaoDestaque = client.clientData.spotlight.description
    },
    methods: {
      fetchEditions(page = 1) {
        let me = this
        const promisse = PortalApi.fetchEditions(page)
        promisse.then((items) => {
          if (items.editions[0] !== undefined)
            me.editionId = items.editions[0].id
        })
      },
      downloadEdition(editionId) {
        return axios.defaults.baseURL + '/editions/downloadPdf/' + editionId
      }
    },
    computed: {
      clientOpacity() {
        return this.client === 'DOE-AL' ? '1' : '0.95'
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/scss/estilos.scss';
  #destaque {
    background-color: $corPrimaria;
    width: calc(100% + 30px);
    margin-right: -15px;
    margin-left: -15px;
    opacity: 0.95;
    box-shadow: $sombraProjetadaCima;
    -webkit-box-shadow: $sombraProjetadaCima;
    #conteudoDestaque {
      .imgHover,
      .efeitoMultiply {
        width: 350px;
        height: 244px;
      }
      .imgHover {
        position: relative;
        z-index: 2;
      }
      .efeitoMultiply {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        z-index: 1;
        background-image: url('../../assets/imagens/gazetaTopo2.png');
        background-color: $corPrimaria;
        background-blend-mode: multiply;
        background-size: 100% 100%;
        opacity: 0.7;
      }
      h3,
      p {
        color: #fff;
      }
      h3 {
        font-weight: 400;
        font-style: italic;
        font-size: 25px;
      }
      p {
        font-size: 15px;
      }
      .botaoDestaque {
        margin: auto;
        padding: 0.375rem 1rem;
        font-size: 0.9rem;
        border: none;
        color: #000;
        font-weight: 400;
        background-color: $corBotaoDestaque;
      }
      .botaoDestaque:hover {
        background-color: $corBotaoDestaqueHover;
      }
      #destaqueGrande {
        .botaoDestaque {
          margin-top: 20px;
        }
      }
      #destaqueReduzido {
        .botaoDestaque {
          margin-top: 30px;
        }
      }
      #ultimaEdicao {
        cursor: pointer;
      }
    }
    #barraSecundaria {
      height: 6px;
      background-color: $corSecundaria;
      box-shadow: $sombraProjetadaCima;
      -webkit-box-shadow: $sombraProjetadaCima;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/destaque.vue